<template>
  <LmDialog v-model="showModal" :title="title" :styles="{ minHeight: '200px', minWidth: '1200px' }">
    <template #toolbar-actions>
      <q-btn :loading="loading" size="sm" color="tertiary" label="Save" @click.prevent="save" />
    </template>

    <template #content>
      <q-card-section class="modal-content-wrapper">
        <div v-if="!data" class="fit flex items-center justify-center">
          <q-spinner color="primary" size="2.5em" />
        </div>

        <div v-else class="modal-content">
          <SettingsCard v-if="data.settings.length" :data-settings="data.settings" />
          <EmailTemplates
            v-if="data.email_template_settings"
            :data-email-templates="data.email_template_settings"
            @new-template="addNewTemplate"
            @set-default="setDefaultTemplate"
            @delete-template="deleteTemplate"
            @update-name="updateName"
          />
        </div>
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import * as apiTo from './api'
// Libraries
import moment from 'moment'
// Components
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'
import SettingsCard from './SettingsCard'
import EmailTemplates from './EmailTemplates'

export default {
  components: {
    LmDialog,
    SettingsCard,
    EmailTemplates
  },

  props: {
    value: {
      type: Boolean
    },

    title: {
      type: String,
      required: true
    },

    slug: {
      type: String,
      required: true
    }
  },

  data: () => ({
    data: null,
    loading: false
  }),

  computed: {
    showModal: {
      get() {
        return this.value
      },

      set(newVal) {
        this.$emit('input', newVal)
      }
    },

    defaultTemplateIndex() {
      if (!this.data?.email_template_settings) return
      return this.data.email_template_settings.email_templates.findIndex(t => t.default === true)
    }
  },

  watch: {
    showModal(newVal) {
      if (newVal) this.getSingleTaskData(this.slug)
      else this.data = null
    }
  },

  methods: {
    getSingleTaskData(slug) {
      apiTo.getMilestoneSettings(slug).then(({ data }) => (this.data = data.result))
    },

    addNewTemplate(templateName) {
      const newTemplate = {
        id: moment().format('YYYY-MM-DD-HH:mm:ss'), // unique id
        body: '',
        default: false,
        name: templateName,
        email_template_type_id: this.data.email_template_settings.id,
        subject: ''
      }

      this.data.email_template_settings.email_templates.push(newTemplate)
    },

    setDefaultTemplate(templateIndex) {
      this.data.email_template_settings.email_templates[this.defaultTemplateIndex].default = false
      this.data.email_template_settings.email_templates[templateIndex].default = true
    },

    deleteTemplate(indexToDelete) {
      this.data.email_template_settings.email_templates.splice(indexToDelete, 1)
    },

    updateName({ index, newName }) {
      this.data.email_template_settings.email_templates[index].name = newName
    },

    save() {
      this.loading = true
      apiTo
        .updateMilestoneSettings(this.slug, this.data)
        .then(() => (this.showModal = false))
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

styledScrollFor('.modal-content-wrapper')

.modal-content-wrapper {
  overflow auto

  .modal-content {
    display grid
    gap 10px
  }
}
</style>
